import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomProductUseMantainanceComponent } from './custom-product-use-mantainance.component';


@NgModule({
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ProductUseAndMantainanceTabComponent: {
                    component: CustomProductUseMantainanceComponent,
                },
            },
        } as CmsConfig),
        I18nModule,
    ],
    declarations: [CustomProductUseMantainanceComponent],
    exports: [CustomProductUseMantainanceComponent]
})

export class CustomProductUseMantainanceModule {
}
